import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { initializeApiLogger } from './utils/apiLogger';

// Initialize the global fetch interceptor to catch and report 503s
initializeApiLogger();

// PWA Registration
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // A vite-plugin-pwa gera o sw.js automaticamente em implantação
    navigator.serviceWorker.register('/sw.js').catch((error) => {
      console.log('SW registration failed: ', error);
    });
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
